export default "__VITE_ASSET__CJO4Co1r__"